import api from './api';

export interface FineTuneJob {
  id: string;
  name: string;
  base_model: string;
  status: string;
  remote_id?: string | null;
  result_model?: string | null;
  dataset_size: number;
  eval_summary?: any;
  error?: string | null;
  created_by?: string;
  created_at?: string;
  updated_at?: string;
}

export interface AutomationStatus {
  auto_train_enabled: boolean;
  auto_train_threshold: number;
  auto_train_base_model: string;
  auto_promote_enabled: boolean;
  new_golden_since_last_job: number;
  active_job: boolean;
  champions: Record<string, string>;
}

export type AutomationPatch = Partial<{
  auto_train_enabled: boolean;
  auto_train_threshold: number;
  auto_train_base_model: string;
  auto_promote_enabled: boolean;
}>;

class TrainingService {
  async datasetPreview(): Promise<{ examples: number }> {
    return (await api.get('/training/dataset')).data;
  }
  async getAutomation(): Promise<AutomationStatus> {
    return (await api.get('/training/automation')).data;
  }
  async setAutomation(cfg: AutomationPatch): Promise<AutomationStatus> {
    return (await api.put('/training/automation', cfg)).data;
  }
  async start(name: string, baseModel: string): Promise<{ job: FineTuneJob }> {
    return (await api.post('/training/start', { name, base_model: baseModel })).data;
  }
  async jobs(): Promise<{ jobs: FineTuneJob[] }> {
    return (await api.get('/training/jobs')).data;
  }
  async job(id: string): Promise<{ job: FineTuneJob }> {
    return (await api.get(`/training/jobs/${id}`)).data;
  }
  async promote(id: string): Promise<{ job: FineTuneJob }> {
    return (await api.post(`/training/jobs/${id}/promote`, {})).data;
  }
}

export const trainingService = new TrainingService();
export default trainingService;
